import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const DoubleColumnLayout = styled.div`
    width: 100%;
    margin-top: 32px;
    
    display: grid;
    flex-wrap: nowrap;
    grid-template-columns: 1fr 480px;
    align-items: flex-start;
    gap: 32px;
    max-width: 100%;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-template-columns: 1fr 384px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-template-columns: 100%;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 16px;
    }
`;

export const Block = styled.div`
    display: block;
`;

export const TwoInRow = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
`;

export const TwoInRowWithExtraSpace = styled(TwoInRow)`
    margin-bottom: 12px;
    &:last-child {
        margin-bottom: 0;
    }
`;

export const TabsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    margin: 0 0 32px;
  
    & > nav {
      gap: 8px;
    }

    @media (min-width: ${wideBreakpoints.mobile}) {
        div:last-child {
            display: none;
        }
        margin: 0 0 48px;
    }
`;

export const RightSide = styled.div`
  @media (min-width: ${wideBreakpoints.laptop}) {
    height: 100%;
  }
`;
